export default {
  setNumeration(state,payload){

    state.numeration = payload.numeration;

  },
  setListInvoices(state,payload){

    state.listInvoices = payload.listInvoices;

  },
  // Nueva mutación para notas de crédito
  setCreditNoteNumeration(state, payload) {
    state.creditNoteNumeration = payload.numeration;
  }
};
